import dayjs from "dayjs";

export function getPageLink(page) {
  const idAbout = 1569;
  // const idProgramme = 2783

  if (page.post_parent === idAbout) {
    return { name: "About", params: { page: page.post_name } };
  } else {
    return { name: "Programme", params: { page: page.post_name } };
  }
}

export function getImageSrcSetNonLazy(image, imageClass = "") {
  return `<div class='${imageClass}'><img srcset='${image.sizes.medium} 400w, ${image.sizes.medium_large} 600w, ${image.sizes.large} 1000w, ${image.sizes["extra-large"]} 1900w' class="col-12" />`;
}

export function getImageSrcSet(image, imageClass = "") {
  return `<div class='${imageClass}'><img data-srcset='${image.sizes.medium} 400w, ${image.sizes.medium_large} 600w, ${image.sizes.large} 1000w, ${image.sizes["extra-large"]} 1900w' class="col-12" />`;
}

export function strPadLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

export function inViewport(el) {
  let rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight ||
        document.documentElement.clientHeight) /*or $(window).height() */ &&
    rect.right <=
      (window.innerWidth ||
        document.documentElement.clientWidth) /*or $(window).width() */
  );
}

export function getVideoTimeFromSeconds(time, showMS = false) {
  let minutes = Math.floor(time / 60);
  let seconds = time - minutes * 60;
  if (!showMS) {
    return strPadLeft(minutes, "0", 2) + ":" + strPadLeft(seconds, "0", 2);
  } else {
    return strPadLeft(minutes, "0", 2) + ":" + strPadLeft(seconds, "0", 2);
  }
}

export function getRelated(item, type) {
  if (item.acf.related) {
    let items = item.acf.related.filter(
      (relatedItem) => relatedItem.post_type === type
    );

    if (items.length > 0) {
      return items;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function exhibitionCategory(item) {
  if (item.type) {
    return item.type[0].name;
  } else {
    return false;
  }
}

export function exhibitionDates(item) {
  return `${formatDate(item.start.date, "DD MMM YYYY")} - ${formatDate(
    item.end.date,
    "DD MMM YYYY"
  )}`;
}

export function exhibitionDistance(item, prefix = "Opens ") {
  let currentDate = dayjs(Date.now());
  let startDate = dayjs(item.start.date);
  let endDate = dayjs(item.end.date);

  if (currentDate.isBefore(startDate)) {
    let dayDiff = startDate.diff(currentDate, "days");
    if (dayDiff > 30) {
      return `${prefix}in ${Math.floor(dayDiff / 30)} Months`;
    } else if (dayDiff > 1) {
      return `${prefix}in ${dayDiff} Days`;
    } else if (dayDiff === 1) {
      return `${prefix}Tomorrow`;
    } else {
      return `${prefix}Today`;
    }
  } else {
    let dayDiff = endDate.diff(currentDate, "days");
    if (dayDiff > 30) {
      if (Math.floor(dayDiff / 30) === 1) {
        return "Ends in 1 Month";
      } else {
        return `Ends in ${Math.floor(dayDiff / 30)} Months`;
      }
    } else if (dayDiff > 1) {
      return `Ends in ${dayDiff} Days`;
    } else if (dayDiff === 1) {
      return "Ends Tomorrow";
    } else {
      return `Ends Today`;
    }
  }
}

export function exhibitionStatus(item) {
  if (this.dateIsBefore(item.start.date)) {
    return "Upcoming ⤻ ";
  } else if (this.dateIsBefore(item.end.date)) {
    return "<span class='red'>Now ⤻ </span>";
  } else {
    return "";
  }
}

export function sortExhibitions(exhibitions) {
  return exhibitions.sort((b, a) => {
    // Start Is Before
    if (dayjs(a.start.date).isBefore(dayjs(b.start.date))) {
      return -1;
    }
    // Start Is After
    if (dayjs(a.start.date).isAfter(dayjs(b.start.date))) {
      return 1;
    }
    // Start Is Same
    if (dayjs(a.start.date).isSame(dayjs(b.start.date))) {
      // End Is Before
      if (dayjs(a.end.date).isBefore(dayjs(b.end.date))) {
        return 1;
      }
      // End Is After
      if (dayjs(a.end.date).isAfter(dayjs(b.end.date))) {
        return -1;
      }
      // End Is Same
      if (dayjs(a.end.date).isSame(dayjs(b.end.date))) {
        return 0;
      }
    }
  });
}

export function filterAreas(areas, key) {
  return areas.filter((area) => area.name !== key);
}

export function separateArea(all, key) {
  let investigations = [];
  let studies = [];
  all.forEach((inv) => {
    let isMain = true;
    if (inv.investigation_area) {
      inv.investigation_area.forEach((area) => {
        if ("name" in area && area["name"] === key) isMain = false;
      });
    }
    if (isMain) investigations.push(inv);
    else {
      studies.push(inv);
    }
  });

  return [studies, investigations];
}

export function sortPublications(items) {
  let sorted = items;

  sorted.sort((a, b) => {
    if (a.acf.year > b.acf.year) {
      return -1;
    } else {
      return 1;
    }
  });

  return sorted;
}

export function eventDates(item, format = "DD MMM YYYY") {
  // console.log(item)

  let dateOutput = "";

  // IF no start date supplied
  if (!item.start.date) {
    dateOutput = "-";
  } else {
    // IF today is before start date
    if (this.dateIsBefore(item.start.date)) {
      dateOutput = `${formatDate(item.start.date, format)}`;

      // IF start not all day, and has time
      if (!item.start.all_day && item.start.time_start) {
        dateOutput = `${dateOutput}, ${item.start.time_start}`;
      }

      // IF has an end date
      if (item.end.date && item.end.date != item.start.date) {
        dateOutput = `${dateOutput} - ${formatDate(item.end.date, format)}`;
      }

      // IF end not all day, and has time
      if (!item.end.all_day && item.end.time_end) {
        dateOutput = `${dateOutput} – ${item.end.time_end}`;
      }
    } else if (this.dateIsBefore(item.end.date)) {
      // IF end date is before today
      dateOutput = `Until ${formatDate(item.end.date, format)}`;

      // IF end not all day, and has time
      if (!item.end.all_day && item.end.time_end) {
        dateOutput = `${dateOutput}, ${item.end.time_end}`;
      }
    } else {
      // IF event has ended
      dateOutput = `${formatDate(item.start.date, format)}`;
      if (!item.start.all_day && item.start.time_start) {
        dateOutput = `${dateOutput}, ${item.start.time_start}`;
      }

      if (item.end.date && item.end.date != item.start.date) {
        // Ends different days
        dateOutput = `${dateOutput} - ${formatDate(item.end.date, format)}`;
        if (!item.end.all_day && item.end.time_end) {
          // Has end time
          dateOutput = `${dateOutput}, ${item.end.time_end}`;
        }
      } else {
        // Ends same day, and has end time
        if (!item.end.all_day && item.end.time_end) {
          dateOutput = `${dateOutput} - ${item.end.time_end}`;
        }
      }
    }
  }

  return dateOutput;
}

export function incidentDates(item) {
  let dateObj =
    item.event_dates || (item.hasOwnProperty("acf") && item.acf.event_dates);

  if (!dateObj) return "None";

  if (dateObj.date_start.type.length !== 0) {
    let incidentDates = "";

    if (dateObj.date_start.type === "freetext") {
      incidentDates = dateObj.date_start.freetext;
    } else {
      incidentDates = formatDate(dateObj.date_start.date, "D MMM YYYY");
    }

    if (dateObj.date_end.type === "freetext") {
      incidentDates += ` - ${dateObj.date_end.freetext}`;
    } else if (dateObj.date_end.type === "datepicker") {
      incidentDates += " - " + formatDate(dateObj.date_end.date, "D MMM YYYY");
    } else if (dateObj.date_end.type === "ongoing") {
      incidentDates += " - Ongoing";
    }

    return incidentDates;
  } else {
    return "None";
  }
}

export function isStudy(content) {
  if (
    content &&
    content.hasOwnProperty("investigation_area") &&
    content.investigation_area
  )
    return (
      content.investigation_area.filter((a) => a.name === "Study").length === 1
    );
  else if (content && content.hasOwnProperty("area")) {
    return (
      content.area &&
      content.area.filter((a) => a.name === "Study").length === 1
    );
  }
}

export function isExhibition(content) {
  if (content.venue) return true;
  return false;
}

export function sortInvestigations(a, b) {
  const adate = isStudy(a) ? a.publication_date : a.event_dates.date_start.date;
  const bdate = isStudy(b) ? b.publication_date : b.event_dates.date_start.date;

  if (adate > bdate) return -1;
  else if (bdate > adate) return 1;
  return 0;
}

export function sortSubdomainContent(a, b) {
  const adate = formatDate(
    "publication_date" in a ? a.publication_date : a.start.date
  );
  const bdate = formatDate(
    "publication_date" in b ? b.publication_date : b.start.date
  );
  if (adate > bdate) return -1;
  else if (bdate > adate) return 1;
  return 0;
}

export function foldAccents(s) {
  let accentMap = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
  };

  if (!s) {
    return "";
  }

  let ret = "";
  for (var i = 0; i < s.length; i++) {
    ret += accentMap[s.charAt(i)] || s.charAt(i);
  }
  return ret;
}

export function formatDate(dateString, formatString = "DD MMM YYYY") {
  if (dateString) {
    return dayjs(dateString).format(formatString);
  } else {
    return false;
  }
}

export function collaborators(investigation) {
  if (investigation.acf.collaborating_organizations) {
    let items = [];
    investigation.acf.collaborating_organizations.map((x) => {
      items.push(x.post_title);
    });
    return items.join(", ");
  } else {
    return false;
  }
}

export function joinArray(arr, ifEmpty) {
  if (arr !== "" && arr.length > 0) {
    let items = [];
    arr.map((x) => {
      items.push(x.post_title);
    });
    return items.join(", ");
  } else {
    return ifEmpty;
  }
}

export function commissionedByHeading(investigation) {
  if (investigation.commissioned_by_heading !== null) {
    return investigation.commissioned_by_heading;
  } else {
    return "Commissioned By";
  }
}

export function commissionedBy(investigation) {
  if (investigation.commissioned_by.length > 0) {
    return investigation.commissioned_by.join(", ");
  } else {
    return "Self-Initiated";
  }
}

export function getPreviewImageFile(item) {
  if (item.feature_image) {
    return item.feature_image.sizes.large;
  } else {
    return false;
  }
}

export function getPreviewImageStyle(item) {
  return {
    backgroundImage: `url(${getPreviewImageFile(item)})`,
  };
}

export function getPreviewVideoFile(item) {
  if (item.preview_videos !== undefined) {
    let file = item.preview_videos.find((file) => file.height === 360);

    if (file.length === 0) {
      file = item.preview_videos.find((file) => file.quality === "hd");
    }

    return file["link"];
  } else {
    return false;
  }
}

export function formatForSearch(s) {
  return foldAccents(s.toLowerCase());
}

// export function getFormattedVideoDate (timestamp) {
//   return fecha.format(fecha.parse(timestamp, 'YYYY-MM-DDTHH:ss:SS.ZZ'), 'DD.MM.YYYY')
// }
